<!--
 * @Author: your name
 * @Date: 2020-12-12 21:52:32
 * @LastEditTime: 2022-12-07 10:49:51
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-menu/components/closeTab/index.vue
-->
<style scoped lang="sass">
$color: var(--menu-primary-text-colour)
$bgc: var(--menu-primary-background-colour)

.app_container

.title
  margin-bottom: 25px
  line-height: 20px
  font-size: 17px
  color: $color
  text-align: center

.info
  text-align: center
  font-size: 14px
  line-height: 18px
  color: $color
  opacity: 0.75

.field_wrap

</style>

<template lang="pug">
.app_container
  .title.b {{ isSetTabAmount ? t('add_funds', 'Add funds') : t('set_limit', 'Set limit') }}
  .info.van-cell--center(v-show="isSetTabAmount") {{ t('added_to_limit', 'This will be added to your limit of') }} #[b {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ fmtDec(parseFloat(tabAmount)) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}]

  .field_wrap.mt30.mb40
    van-form(ref="form")
      input-field(
        v-model.number="num"
        :name="isSetTabAmount ? t('amount', 'Amount') : t('enter_tab_limit', 'Enter your tab limit')"
        label="$"
        label-width="3px"
        type="digit"
        min="1"
        :rules="rules"
      )
      .info(v-if="isShowInfo") {{ info }}

  van-button.button.b.ls1(
    @click="submit"
    type="primary"
    :disabled="!num"
  ) {{ isSetTabAmount ? t('add_funds_button', 'ADD FUNDS') : t('set_limit_button', 'SET LIMIT') }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import InputField from '../../../components/input-field'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  components: {
    InputField,
  },

  props: {
    showIncreaseTab: Boolean,
    currentAmount: Number,
    tabAmount: [Number, String],
    isSetTabAmount: Boolean,
    tabDetailType: Number, // 接口返回的 tabDetailType
  },

  computed: {
    // 判断 note 是否显示
    isShowInfo() {
      return this.tabDetailType !== 2 // 2 代表是用户创建的派对，其他是管理员创建的
    },
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  },

  watch: {
    showIncreaseTab: {
      handler(val) {
        // 显示弹窗时，判断是否要添加表单验证
        if (val) {
          this.rules = this.isSetTabAmount ? [] : [{ validator: this._validateSetTabAmount, message: t('set_amount_greater', 'Set amount must be greater than tab amount') }]
        } else {
        // 关闭弹窗后，初始化数据
          this.rules = []
          this.num = ''
        }
      },
      immediate: true
    }
  }
})

class IncreaseTab extends Vue {
  info = t('pre_authorisation_note', 'Note: A pre-authorisation will be placed on your card for the new limit amount to ensure there are sufficient funds.')
  num = ''
  rules = []

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  fmtDec(val) { return formatDecimalNumber(val) }

  async submit() {
    await this.$refs.form.validate()
    this.$emit('submit', this.num)
  }

  _validateSetTabAmount(val) {
    return Number(val) > Number(this.tabAmount)
  }
}

export default IncreaseTab
</script>
